import React, { Component } from "react";
import bitcoin from "../assets/card/bitcoin@2x.png";
import ethereum from "../assets/card/ethereum@2x.png";
import xrp from "../assets/card/xrp@2x.png";
import "./bestRates.css";

class BestRates extends Component {
  state = {};
  render() {
    return (
      <div className="best">
        <div className="container-fluid contBest">
          <div className="row">
            <div className="col-md-4">
              <img src={bitcoin} alt="" className="img-fluid" />
            </div>
            <div className="col-md-4 hide">
              <img src={ethereum} alt="" className="img-fluid" />
            </div>
            <div className="col-md-4 hide">
              <img src={xrp} alt="" className="img-fluid" />
            </div>
          </div>
          <div className="row">
            <div className="col ctr">
              <h1 className="Best-rate-everyday">Best rate everyday </h1>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BestRates;
